import { Box } from "@mui/material";

export default function ProfileIcon() {
  return (
    <Box  >

    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_891_468)"  >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 0.744003C9.54147 0.744533 8.14283 1.32417 7.1115 2.3555C6.08016 3.38684 5.50053 4.78548 5.5 6.244C5.5 9.279 7.964 11.744 11 11.744C14.036 11.744 16.5 9.279 16.5 6.244C16.5 3.208 14.036 0.744003 11 0.744003ZM11 2.244C13.208 2.244 15 4.036 15 6.244C15 8.451 13.208 10.244 11 10.244C8.792 10.244 7 8.451 7 6.244C7 4.036 8.792 2.244 11 2.244ZM21.25 17.002C21.2492 15.8745 20.801 14.7935 20.0037 13.9963C19.2065 13.199 18.1255 12.7508 16.998 12.75H5.002C3.87454 12.7508 2.79349 13.199 1.99626 13.9963C1.19903 14.7935 0.750795 15.8745 0.75 17.002V17.004C0.750795 18.1315 1.19903 19.2125 1.99626 20.0097C2.79349 20.807 3.87454 21.2552 5.002 21.256H16.998C18.1255 21.2552 19.2065 20.807 20.0037 20.0097C20.801 19.2125 21.2492 18.1315 21.25 17.004V17.002ZM19.75 17.002V17.004C19.75 17.7339 19.4601 18.4339 18.944 18.95C18.4279 19.4661 17.7279 19.756 16.998 19.756H5.002C4.27212 19.756 3.57214 19.4661 3.05604 18.95C2.53994 18.4339 2.25 17.7339 2.25 17.004V17.002C2.25 16.2721 2.53994 15.5721 3.05604 15.056C3.57214 14.5399 4.27212 14.25 5.002 14.25H16.998C17.7279 14.25 18.4279 14.5399 18.944 15.056C19.4601 15.5721 19.75 16.2721 19.75 17.002Z"
          fill="#959595"
          />
      </g>
      <defs>
        <clipPath id="clip0_891_468">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
          </Box>
  );
}
